export const CHOICES_DATA = [
  {
    label: "Auto Resize Choices",
    value: "autoResizeChoice",
  },
  {
    label: "Keep Question Text Fixed on the screen",
    value: "keepQuestionTextFixed",
  },
  {
    label: "Display On Confirmation",
    value: "displayOnConfirmation",
  },
  {
    label: "Is Instruction",
    value: "isInstruction",
  },
];

export const SAS_DATA_TYPES = [
  { key: "INTEGER", value: "INTEGER" },
  { key: "STRING", value: "STRING" },
];

export const STUDY_FILES_OPTIONS = [
  {
    label: "Study File",
    value: "Study File",
  },
  {
    label: "Study File 2",
    value: "Study File 2",
  },
  {
    label: "Study File 3",
    value: "Study File 3",
  },
];

export const BUSINESS_DATA = [
  {
    label: "Is Blinded",
    value: "isBlinded",
  },
  {
    label: "Display Summary Score",
    value: "displaySummaryScore",
  },
  {
    label: "Is Dropdown Navigation Enabled",
    value: "isDropdownNavigationEnabled",
  },
  {
    label: "Validate Questionnaire On Save",
    value: "validateQuestionnaire",
  },
  {
    label: "Prompt Incomplete Pages On Save",
    value: "promptIncompletePages",
  },
];

export const OPEN_ENDED_OPTIONS = [
  {
    label: "123",
    value: "123",
  },
  {
    label: "ABC",
    value: "ABC",
  },
  {
    label: "XYZ",
    value: "XYZ",
  },
];

export const EDIT_OPTIONS = [
  {
    label: "Enforce Previous Days Entry",
    value: "enforcePreviousDaysEntry",
  },
  {
    label: "Allow Edit",
    value: "allowEdit",
  },
];

export const PAGE_CONTAINER_OPTIONS = [
  { label: "Is HandWriting Enabled", value: "isHandWritingEnabled" },
  { label: "Is Scroll For More Enabled", value: "isScrollEnabled" },
];

export const inputFieldArray = [
  { inputFieldId: 1, questionType: "None" },
  { inputFieldId: 2, questionType: "singleradio" },
  { inputFieldId: 3, questionType: "checkbox" },
  { inputFieldId: 4, questionType: "NumberSpinner" },
  { inputFieldId: 5, questionType: "file" },
  { inputFieldId: 6, questionType: "text" },
  { inputFieldId: 7, questionType: "NRS" },
  { inputFieldId: 8, questionType: "date" },
  { inputFieldId: 9, questionType: "time" },
  { inputFieldId: 10, questionType: "vas" },
  { inputFieldId: 19, questionType: "eq5d5l" },
  { inputFieldId: 12, questionType: "singleCheckbox" },
  { inputFieldId: 13, questionType: "HotSpotSingleSelect" },
  { inputFieldId: 14, questionType: "HotSpotMultipleSelect" },
  { inputFieldId: 15, questionType: "patientVisitDrugKitStatus" },
  { inputFieldId: 16, questionType: "replaceDrugKit" },
  { inputFieldId: 17, questionType: "dispenseDrugKit" },
  { inputFieldId: 18, questionType: "DobDatePicker" },
  { inputFieldId: 19, questionType: "visitdatepicker" },
  { inputFieldId: 20, questionType: "YearSelect" },
  { inputFieldId: 21, questionType: "ageRangeYear" },
  { inputFieldId: 22, questionType: "DateTime" },
  { inputFieldId: 23, questionType: "videourl" },
  { inputFieldId: 24, questionType: "RadioButtonImage" },
  { inputFieldId: 25, questionType: "DurationSpinner" },
  { inputFieldId: 26, questionType: "assignDrugKit" },
  { inputFieldId: 27, questionType: "AvailableCohortSelector" },
  { inputFieldId: 28, questionType: "CollectInitials" },
  { inputFieldId: 29, questionType: "genderRadioGroup" },
  { inputFieldId: 18, questionType: "ageDateRange" },
];
